export default function GoldenSpiral({ size = 200, className = '', opacity = 0.08 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 200 200"
      className={`${className}`}
      style={{ opacity }}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M100 100 C100 55.8 131.3 20 170 20 C170 58.7 138.7 90 100 90 C100 68.9 118.9 52 140 52 C140 73.1 121.1 90 100 90 C100 78.9 109 70 120 70 C120 81 111 90 100 90 C100 84.5 104.5 80 110 80 C110 85.5 105.5 90 100 90"
        stroke="#C9A84C"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M100 100 C100 144.2 68.7 180 30 180 C30 141.3 61.3 110 100 110 C100 131.1 81.1 148 60 148 C60 126.9 78.9 110 100 110 C100 121.1 91 130 80 130 C80 119 89 110 100 110 C100 115.5 95.5 120 90 120 C90 114.5 94.5 110 100 110"
        stroke="#C9A84C"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <circle cx="100" cy="100" r="3" fill="#C9A84C" opacity="0.6" />
    </svg>
  );
}
